import { render, staticRenderFns } from "./enclosure-add-or-update.vue?vue&type=template&id=47632422&scoped=true&"
import script from "./enclosure-add-or-update.vue?vue&type=script&lang=js&"
export * from "./enclosure-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./enclosure-add-or-update.vue?vue&type=style&index=0&id=47632422&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47632422",
  null
  
)

export default component.exports